export default [
    {
        path: '/checkout-schedule/weekday-config',
        name: 'checkout_schedule_weekday_config',
        component: () => import('@src/click-and-collect/checkout-schedule-weekday-config.vue'),
        meta: {
            title: 'Terminkapazitäten pro Wochentag',
            role: 'ROLE_EDIT_CHECKOUT_SCHEDULE_CONFIG',
        },
    },
    {
        path: '/checkout-schedule/calendar',
        name: 'checkout_schedule_calendar',
        component: () => import('@src/click-and-collect/checkout-schedule-calendar.vue'),
        meta: {
            title: 'Kalender',
            role: 'ROLE_CLICK_AND_COLLECT',
        },
    },
    {
        path: '/checkout-schedule/availability-config',
        name: 'checkout_schedule_availability_config',
        component: () => import('@src/click-and-collect/checkout-schedule-availablility-config.vue'),
        meta: {
            title: 'Termineinstellungen',
            role: 'ROLE_EDIT_CHECKOUT_SCHEDULE_CONFIG',
        },
    },
    {
        path: '/click-and-collect/collect-bin-clearing',
        name: 'click_and_collect_collect_bin_clearing',
        component: () => import('@src/click-and-collect/collect-bin-clearing.vue'),
        meta: {
            title: 'Abholplatz aufräumen',
            role: 'ROLE_CLICK_AND_COLLECT',
        },
    },
];
